import { MessageFormatElement, RawIntlProvider } from 'react-intl'
import { PropsWithChildren } from 'react'
import { fetchIntl } from '../strings'
import { useQuery } from '@tanstack/react-query'

export type IntlMessages = Record<string, MessageFormatElement[]>

export const TranslationsProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { data: value } = useQuery({
    queryKey: ['intl'],
    queryFn: async () => fetchIntl(),
  })

  return value ? (
    <RawIntlProvider value={value}>{children}</RawIntlProvider>
  ) : null
}
